<template>
  <section class="content" style="background-color: #EBECF1">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-info">
          <div class="box-header">
            <div class="row">
              <div class="col-md-2">
                <h3 class="fuente box-title p-t-5">Detalle de la Aplicación:</h3>
              </div>
              <div class="col-md-8">
                <h3 class="fuente box-title p-t-10">{{ this.descripcionApp }}</h3>
              </div>
            </div>
          </div>
          <br />
          <div class="box-body">
            <div id="app">
              <vue-tabs active-tab-color="#C82626" active-text-color="white" type="pills" text-position="center"
                centered @tab-change="handleTabChange" style="border-radius: 5px;">
                <v-tab title=" PERSONAL" icon="fa fa-users">
                  <!-- <div style="font-size: 18px; text-align: center;">PERSONAL</div> -->
                  <form role="form">
                    <div class="row">
                      <div class="col-md-12 border-table">
                        <br />
                        <!-----Tabla 1 Trabajadores (arriba centro)-->
                        <div class="tabla-1">
                          <div class="box-header" style="padding-left:15px;">
                            <button type="button" class="fuente btn btn-primary fs-13" @click="getAllPersonal()"
                              data-toggle="modal" data-target="#modalNuevoPersonal">Nuevo Registro</button>
                          </div>
                          <!-- <div class="col-md-10">
                              <h3 class="fuente box-title p-t-10">PERSONAL</h3> 
                            </div> -->
                          <div class="fuente col-xs-12 table-responsive">
                            <table id="tablaTrabajadores" aria-describedby="tablaTrabajadores_info" role="grid"
                              class="fuente fs-12 table table-bordered table-striped dataTable">
                              <thead>
                                <tr role="row">
                                  <th aria-label="ITEM" aria-sort="ascending" aria-controls="tablaTrabajadores"
                                    tabindex="0" class="sorting_asc">
                                    ITEM</th>
                                  <th aria-label="DNI" aria-controls="tablaTrabajadores" tabindex="0" class="sorting">
                                    DNI
                                  </th>
                                  <th aria-label="NOMBRES" aria-controls="tablaTrabajadores" tabindex="0"
                                    class="sorting">
                                    NOMBRES
                                  </th>
                                  <th aria-label="CARGO" aria-controls="tablaTrabajadores" tabindex="0" class="sorting">
                                    CARGO
                                  </th>
                                  <th aria-label="CORREO" aria-controls="tablaTrabajadores" tabindex="0"
                                    class="sorting">
                                    CORREO
                                  </th>
                                  <th aria-label="SIGLA" aria-controls="tablaTrabajadores" tabindex="0" class="sorting">
                                    SIGLA
                                  </th>
                                  <th aria-label="FECHA NAC" aria-controls="tablaTrabajadores" tabindex="0"
                                    class="sorting">
                                    FECHA
                                    NACIMIENTO</th>
                                  <th aria-label="USUARIO" aria-controls="tablaTrabajadores" tabindex="0"
                                    class="sorting">
                                    USUARIO
                                  </th>
                                  <th aria-label="DETALLE" aria-controls="tablaTrabajadores" tabindex="0"
                                    class="sorting table-center-header">
                                    DETALLE
                                  </th>
                                  <th aria-label="ANULAR" aria-controls="tablaTrabajadores" tabindex="0"
                                    class="sorting table-center-header">
                                    ANULAR
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(trabajador, indexTrab) in trabajadores" :key="indexTrab.idTrabajador"
                                  role="row">
                                  <td class="sorting_1">{{ indexTrab + 1 }}</td>
                                  <td>{{ trabajador.dni }}</td>
                                  <td>{{ trabajador.nombres }} {{ trabajador.apePaterno }} {{
                  trabajador.apeMaterno }}</td>
                                  <td>{{ trabajador.cargo }}</td>
                                  <td> {{ trabajador.correo }}</td>
                                  <td> {{ trabajador.sigla }}</td>
                                  <td> {{ formatDate(trabajador.fecha_nac) }}</td>
                                  <td> {{ trabajador.nomUsuario }}</td>
                                  <td class="table-center-header">
                                    <router-link
                                      :to="{ name: 'usuarios', params: { idTrab: trabajador.idTrabajador } }"><span
                                        @click="enviar(trabajador.correo, trabajador.idTrabajador)"
                                        class="badge bg-yellow">V</span></router-link>
                                  </td>
                                  <td class="table-center-header">
                                    <span style="cursor:pointer" class="badge bg-red" data-toggle="modal"
                                      @click="verAnularTrabxApp(trabajador)" data-target="#modalAnularTrabxApp">X</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div class="fuente col-md-12" style="color: red;">
                              {{ error.desError }}
                            </div>
                          </div>
                        </div>
                        <div class="modal fade" id="modalNuevoPersonal" tabindex="-1" role="dialog"
                          aria-labelledby="myModalLabel">
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <form>
                                <div class="modal-header">
                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                      aria-hidden="true">X</span></button>
                                  <h4 class="fuente modal-title m-t-10" id="myModalLabel" v-html="texto"></h4>
                                </div>
                                <div class="fuente modal-body fs-12 input-personalizado">
                                  <!--- Se filtra y muestra todos los usuarios de getAllPersonal en el combobox con campo de búsqueda-->
                                  <v-select v-model="selectedIdPersonal" :options="filteredUsuarios" :filterable="true"
                                    label="nombreCompleto" @input="inputHandler"
                                    class="fuente form-control m-t-10 m-b-10 combobox-personalizado"
                                    placeholder="Seleccionar Personal"
                                    style="width: 100%; max-width: 550px; padding: 0px; border-style: hidden;">
                                    <template v-slot:no-options="{ search }">
                                      Lo siento, no hay usuarios que coincidan con "{{ search }}".
                                    </template>
                                  </v-select>
                                  <div v-if="datosPer !== null">
                                    <div class="row">
                                      <div class="col-md-6">
                                        NOMBRES<br />
                                        <input type="text" class="form-control m-t-10 input-personalizado2" readonly
                                          v-model="usuarioSeleccionado.nombres" /><br />
                                      </div>
                                      <div class="col-md-6">
                                        APELLIDOS<br />
                                        <input type="text" class="form-control m-t-10 input-personalizado2" readonly
                                          :value="`${usuarioSeleccionado.apePaterno || ''} ${usuarioSeleccionado.apeMaterno || ''}`" /><br />
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        DNI<br />
                                        <input type="text" class="form-control m-t-10 input-personalizado2" readonly
                                          v-model="usuarioSeleccionado.dni" /><br />
                                      </div>
                                      <div class="col-md-6">
                                        CARGO<br />
                                        <input type="text" class="form-control m-t-10 input-personalizado2" readonly
                                          v-model="usuarioSeleccionado.cargo" /><br />
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        CORREO<br />
                                        <input type="text" class="form-control m-t-10 input-personalizado2" readonly
                                          v-model="usuarioSeleccionado.correo" /><br />
                                      </div>
                                      <div class="col-md-6">
                                        FECHA NACIMIENTO<br />
                                        <input type="text" class="form-control m-t-10 input-personalizado2" readonly
                                          :value="formatDate(usuarioSeleccionado.fecNacimiento)" /><br />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div v-if="datosPer !== null" class="fuente col-xs-12 table-responsive">
                                      <div class="box-body">
                                        <table aria-describedby="tablaUsers_info" role="grid" id="tablaUsers"
                                          class="fuente fs-12 table table-bordered table-striped dataTable">
                                          <thead>
                                            <tr role="row">
                                              <th aria-label="ITEM" aria-sort="ascending" aria-controls="tablaUsers"
                                                tabindex="0" class="sorting_asc">ITEM
                                              </th>
                                              <th aria-label="NOMBRE_USUARIO" aria-controls="tablaUsers" tabindex="0"
                                                class="sorting_asc">NOMBRE USUARIO
                                              </th>
                                              <th aria-label="AGREGAR" aria-controls="tablaUsers" tabindex="0"
                                                class="sorting table-center-header">
                                                AGREGAR
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr class="even" role="row" v-for="(item, indexUsu) in datosPer"
                                              :key="indexUsu.idUsuario">
                                              <td class="sorting_1">{{ indexUsu + 1 }}</td>
                                              <td>{{ item.nomUsuario }}</td>
                                              <td><button type="button"
                                                  class="fuente btn btn-primary fs-13 enabled-button2"
                                                  @click="mergePersonal(item.idUsuario)" data-dismiss="modal"> Aceptar
                                                </button>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    <div v-if="datosPer == null" class="modal-footer">
                                      <button type="button" class="fuente btn btn-primary fs-13 disabled-button2"
                                        @click="mergePersonal()" data-dismiss="modal"
                                        :disabled="!datosPer">Aceptar</button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div class="modal fade" id="modalAnularTrabxApp" tabindex="-1" role="dialog"
                          aria-labelledby="myModalLabel">
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <form>
                                <div class="modal-header">
                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                      aria-hidden="true">X</span></button>
                                  <h4 class="fuente modal-title m-t-10" id="myModalLabel">¿DESEAS
                                    ANULAR AL PERSONAL DE ESTA APLICACIÓN?</h4>
                                </div>
                                <div class="fuente modal-body">
                                  Se anulará a {{ trabajador.nombres }}
                                  {{ trabajador.apePaterno }} {{ trabajador.apeMaterno }}
                                  de la aplicación
                                  <br />
                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="fuente btn btn-danger fs-13"
                                    @click="anularTrabxApp(trabajador)" data-dismiss="modal">Anular Personal</button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </v-tab>
                <v-tab title=" ROLES" icon="fa fa-tasks">
                  <form role="form">
                    <div class="row">
                      <div class="col-md-12 border-table">
                        <br />
                        <!-- Tabla 2 Roles (abajo, izquierda) -->
                        <div class="tabla-2">
                          <!-- <h3 class="fuente box-title p-t-10">ROLES</h3> -->
                          <div class="box-header" style="padding-left:15px;">
                            <button type="button" class="fuente btn btn-primary fs-13" @click="limpiarRol()"
                              data-toggle="modal" data-target="#modalNuevoRol">Nuevo Registro</button>
                          </div>
                          <div class="fuente col-xs-12 table-responsive">
                            <table id="tablaRoles" aria-describedby="tablaRoles_info" role="grid"
                              class="fuente fs-12 table table-bordered table-striped dataTable">
                              <thead>
                                <tr role="row">
                                  <th aria-label="ITEM" aria-sort="ascending" aria-controls="tablaRoles" tabindex="0"
                                    class="sorting_asc">ITEM</th>
                                  <th aria-label="ROL" aria-sort="ascending" aria-controls="tablaRoles" tabindex="0"
                                    class="sorting_asc">ROL</th>
                                  <th aria-label="MODIFICAR" aria-controls="tablaRoles" tabindex="0"
                                    class="sorting table-center-header">
                                    MODIFICAR
                                  </th>
                                  <th aria-label="ANULAR" aria-controls="tablaRoles" tabindex="0"
                                    class="sorting table-center-header">
                                    ANULAR
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(rol, indexRol) in rols" :key="indexRol.idRol" role="row">
                                  <td class="sorting_1">{{ indexRol + 1 }}</td>
                                  <td>{{ rol.descripcion }}</td>
                                  <td class="table-center-header"><span style="cursor:pointer" class="badge bg-blue"
                                      data-toggle="modal" @click="verRol(rol)" data-target="#modalNuevoRol">O</span>
                                  </td>
                                  <td class="table-center-header">
                                    <span style="cursor:pointer" class="badge bg-red" data-toggle="modal"
                                      @click="verAnularRolxApp(rol)" data-target="#modalAnularRolxApp">X</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div class="fuente col-md-12" style="color: red;">
                              {{ error2.desError }}
                            </div>
                          </div>
                        </div>
                        <div class="modal fade" id="modalNuevoRol" tabindex="-1" role="dialog"
                          aria-labelledby="myModalLabel">
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <form>
                                <div class="modal-header">
                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                      aria-hidden="true">X</span></button>
                                  <h4 class="fuente modal-title m-t-10" id="myModalLabel" v-html="texto"></h4>
                                </div>
                                <div class="fuente modal-body fs-12">
                                  Descripción:<br />
                                  <input type="text" class="form-control m-t-10" v-model="newRol.descripcion" /><br />
                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="fuente btn btn-primary fs-13" @click="mergeRol()"
                                    data-dismiss="modal" :disabled="!newRol.descripcion">Guardar</button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div class="modal fade" id="modalAnularRolxApp" tabindex="-1" role="dialog"
                          aria-labelledby="myModalLabel">
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <form>
                                <div class="modal-header">
                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                      aria-hidden="true">X</span></button>
                                  <h4 class="fuente modal-title m-t-10" id="myModalLabel">¿DESEAS
                                    ANULAR ESTE ROL DE ESTA APLICACIÓN?</h4>
                                </div>
                                <div class="fuente modal-body">
                                  Se anulará el rol "{{ rol.descripcion }}"
                                  de la aplicación
                                  <br />
                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="fuente btn btn-danger fs-13" @click="anularRolxApp()"
                                    data-dismiss="modal">Anular
                                    Rol</button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </v-tab>
                <v-tab title=" OPERACIONES" icon="fa fa-cogs">
                  <form role="form">
                    <div class="row">
                      <div class="col-md-12  border-table">
                        <br />
                        <!-- ... Tabla 3 Operaciones (abajo, derecha) ... -->
                        <div class="tabla-3">
                          <!-- <h3 class="fuente box-title p-t-10">OPERACIONES</h3> -->
                          <div class="box-header" style="padding-left:15px;">
                            <button type="button" class="fuente btn btn-primary fs-13" @click="limpiarOperacion()"
                              data-toggle="modal" data-target="#modalNuevaOperacion">Nuevo Registro</button>
                          </div>

                          <div class="fuente col-xs-12 table-responsive">
                            <table id="tablaOperaciones" aria-describedby="tablaOperaciones_info" role="grid"
                              class="fuente fs-12 table table-bordered table-striped dataTable">
                              <thead>
                                <tr role="row">
                                  <th aria-label="ITEM" aria-sort="ascending" aria-controls="tablaOperaciones"
                                    tabindex="0" class="sorting_asc">
                                    ITEM</th>
                                  <th aria-label="ROL" aria-sort="ascending" aria-controls="tablaOperaciones"
                                    tabindex="0" class="sorting_asc">
                                    DESCRIPCIÓN</th>
                                  <th aria-label="PRINCIPAL" aria-controls="tablaOperaciones" tabindex="0"
                                    class="sorting">
                                    PRINCIPAL</th>
                                  <th aria-label="OPE SUP" aria-controls="tablaOperaciones" tabindex="0"
                                    class="sorting">
                                    OPE SUP
                                  </th>
                                  <th aria-label="OPE SUP" aria-controls="tablaOperaciones" tabindex="0"
                                    class="sorting">
                                    SECCIÓN
                                  </th>
                                  <th aria-label="ENLACE" aria-controls="tablaOperaciones" tabindex="0" class="sorting">
                                    ENLACE
                                  </th>
                                  <th aria-label="ROL" aria-controls="tablaOperaciones" tabindex="0" class="sorting">ROL
                                  </th>
                                  <th aria-label="ROL" aria-controls="tablaOperaciones" tabindex="0" class="sorting">
                                    ÍCONO
                                  </th>
                                  <th aria-label="ROL" aria-controls="tablaOperaciones" tabindex="0" class="sorting">
                                    TÍTULO
                                    ADICIONAL
                                  </th>
                                  <th aria-label="ROL" aria-controls="tablaOperaciones" tabindex="0" class="sorting">
                                    ÍCONO
                                    ADICIONAL
                                  </th>
                                  <th aria-label="ROL" aria-controls="tablaOperaciones" tabindex="0" class="sorting">
                                    DESCRIPCIÓN
                                    ADICIONAL
                                  </th>
                                  <th aria-label="MODIFICAR" aria-controls="tablaOperaciones" tabindex="0"
                                    class="sorting table-center-header">
                                    MODIFICAR
                                  </th>
                                  <th aria-label="ANULAR" aria-controls="tablaOperaciones" tabindex="0"
                                    class="sorting table-center-header">
                                    ANULAR
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(operacion, indexOpe) in operaciones" :key="indexOpe.idOperacion" role="row">
                                  <td class="sorting_1">{{ indexOpe + 1 }}</td>
                                  <td>{{ operacion.descripcion }}</td>
                                  <td>{{ operacion.principal }}</td>
                                  <td>{{ operacion.opeSup }}</td>
                                  <td>{{ operacion.flagSeccion }}</td>
                                  <td>{{ operacion.enlaceWeb }}</td>
                                  <td>{{ operacion.nomRol }}</td>
                                  <td>{{ operacion.icono }}</td>
                                  <td>{{ operacion.titulo_adic }}</td>
                                  <td>{{ operacion.icono_adic }}</td>
                                  <td>{{ operacion.descripcion_adic }}</td>
                                  <td class="table-center-header"><span style="cursor:pointer" class="badge bg-blue"
                                      data-toggle="modal" @click="verOperacion(operacion)"
                                      data-target="#modalNuevaOperacion">O</span>
                                  </td>
                                  <td class="table-center-header">
                                    <span style="cursor:pointer" class="badge bg-red" data-toggle="modal"
                                      @click="verAnularOpexApp(operacion)" data-target="#modalAnularOpexApp">X</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div class="fuente col-md-12" style="color: red;">
                              {{ error3.desError }}
                            </div>
                          </div>
                        </div>

                        <div class="modal fade" id="modalNuevaOperacion" tabindex="-1" role="dialog"
                          aria-labelledby="myModalLabel">
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <form id="modalNuevaOperacionForm">
                                <div class="modal-header">
                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                      aria-hidden="true">X</span></button>
                                  <h4 class="fuente modal-title m-t-10" id="myModalLabel" v-html="texto"></h4>
                                </div>
                                <div class="fuente modal-body fs-12">
                                  Descripción:<br />
                                  <input type="text" class="form-control m-t-10 m-b-10" v-model="newOpe.descripcion" />
                                  <div class="row m-b-10">
                                    <div class="col-md-6">
                                      Operación Superior :<br />
                                      <div class="position-relative" style="display: flex; align-items: center;">
                                        <!---
                                        <select class="form-control m-t-10 m-b-10 custom-cursor"
                                          v-model="newOpe.idOpeSup">
                                          <option v-for="itemOpe in cbOpes" v-bind:value="itemOpe.idOperacion">
                                            {{ itemOpe.descripcion }}
                                          </option>
                                        </select>
                                        --->

                                        <select class="form-control m-t-10 m-b-10 custom-cursor"
                                          v-model="newOpe.idOpeSup"
                                          :disabled="cbOpes.length === 0 || newOpe.flagPrincipal == '1'"
                                          title="No hay Operaciones Superiores registradas">
                                          <template v-if="cbOpes.length > 0 && newOpe.flagSeccion == 'I'">
                                            <option disabled value="0" selected hidden>Seleccionar</option>
                                            <option v-for="itemOpe in cbOpes" v-bind:value="itemOpe.idOperacion"
                                              :key="itemOpe.idOperacion">
                                              {{ itemOpe.descripcion }}
                                            </option>
                                          </template>
                                          <template v-else-if="operaciones.length > 0 && cbOpes.length > 0 && (newOpe.flagSeccion == 'D' || newOpe.flagSeccion == 'S')">
                                            <option disabled value="0" selected hidden>Seleccionar</option>
                                            <option v-for="itemOpe in operaciones" v-bind:value="itemOpe.idOperacion">
                                              {{ itemOpe.descripcion }}
                                            </option>
                                          </template>
                                          <template v-else>
                                            <option disabled value="0" selected hidden>-
                                            </option>
                                          </template>
                                        </select>
                                        <!---- Botón X para deshacer selección de OpeSup en el combobox, solo visible en Agregar Nuevo --->
                                        <button v-if="newOpe.idOpeSup !== '0' && newOpe.idOperacion === '0'"
                                          @click="resetSelection2" class="clear-button"
                                          title="Deshacer selección de Operación Superior actual">
                                          <!--- <span style="font-weight: bold; font-size: 12px;">X</span> --->
                                          <i class="fa fa-times" style="font-size: 14px;"></i>
                                        </button>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      Rol :<br />
                                      <div class="position-relative" style="display: flex; align-items: center;">
                                        <!------ combobox para obtener los roles en modalNuevaOperacion   ---------->
                                        <select class="form-control m-t-10 m-b-10 custom-cursor" v-model="newOpe.idRol"
                                          :disabled="rols.length === 0">

                                          <template v-if="rols.length > 0">
                                            <option disabled value="0" selected hidden>Seleccionar Rol</option>
                                            <option v-for="itemOpro in rols" v-bind:value="itemOpro.idRol"
                                              :key="itemOpro.idOpeXRol">
                                              {{ itemOpro.descripcion }}
                                            </option>
                                          </template>

                                          <template v-else>
                                            <option disabled value="0" selected hidden>No hay roles disponibles
                                            </option>
                                          </template>
                                        </select>
                                        <!---- Botón X para deshacer selección del Rol en el combobox, solo visible en Agregar Nuevo --->
                                        <button v-if="newOpe.idRol !== '0' && newOpe.idOperacion === '0'"
                                          @click="resetSelection" class="clear-button"
                                          title="Deshacer selección de Rol actual">
                                          <!--- <span style="font-weight: bold; font-size: 12px;">X</span> --->
                                          <i class="fa fa-times" style="font-size: 14px;"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row m-b-10">
                                    <div class="col-md-6">
                                      Es Principal:<br>
                                      <div class="m-t-10 m-l-10">
                                        <input type="checkbox" v-model="newOpe.flagPrincipal" true-value="1"
                                          false-value="0" :disabled="this.newOpe.idOperacion !== '0' && this.newOpe.idOpeSup !== 0">
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      Sección:
                                      <select class="form-control m-t-10" v-model="newOpe.flagSeccion">
                                        <option value="I">I</option>
                                        <option value="D">D</option>
                                        <option value="S">S</option>
                                      </select>
                                    </div>
                                  </div>
                                  Enlace Web:<br />
                                  <input type="text" class="form-control m-t-10" v-model="newOpe.enlaceWeb" />
                                  <br />
                                  <div class="row m-b-10">
                                    <div class="col-md-6">
                                      Ícono:<br>
                                      <input type="text" class="form-control m-t-10 m-b-10" v-model="newOpe.icono" />
                                    </div>
                                    <div class="col-md-6">
                                      Ícono Adicional:
                                      <input type="text" class="form-control m-t-10 m-b-10"
                                        v-model="newOpe.icono_adic" />
                                    </div>
                                  </div>
                                  Título Adicional:<br />
                                  <input type="text" class="form-control m-t-10" v-model="newOpe.titulo_adic" />
                                  <br />
                                  Descripción Adicional:<br />
                                  <input type="text" class="form-control m-t-10" v-model="newOpe.descripcion_adic" />
                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="fuente btn btn-primary fs-13" @click="mergeOperacion()"
                                    data-dismiss="modal" :disabled="!newOpe.descripcion"
                                    :title="!newOpe.descripcion ? 'Para guardar, es necesario rellenar el campo Descripción' : ''">Guardar</button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div class="modal fade" id="modalAnularOpexApp" tabindex="-1" role="dialog"
                          aria-labelledby="myModalLabel">
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <form>
                                <div class="modal-header">
                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                      aria-hidden="true">X</span></button>
                                  <h4 class="fuente modal-title m-t-10" id="myModalLabel">¿DESEAS
                                    ANULAR LA OPERACIÓN DE ESTA APLICACIÓN?</h4>
                                </div>
                                <div class="fuente modal-body">
                                  Se anulará la operación "{{ operacion.descripcion }}"
                                  de la aplicación.
                                  <br />
                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="fuente btn btn-danger fs-13" @click="anularOpexApp()"
                                    data-dismiss="modal">Anular
                                    Operación</button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </v-tab>
              </vue-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import 'datatables.net'
import 'datatables.net-bs'
import axios from 'axios'
import $ from 'jquery'
import { apiURL } from '@/store/state' //llamando al apiURL del store
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { VueTabs, VTab } from 'vue-nav-tabs';
//import App from '../App.vue';
import App from '@/components/App.vue';
import moment from 'moment';

export default {
  name: 'Tables',
  data() {
    return {
      trabajadores: [], //Variable para almacenar trabajadores 
      operaciones: [], //Variable  para almacenar las operaciones 
      rols: [], //Variable para almacenar los roles  
      //opes: [],
      texto: '',
      error: {
        desError: ''
      },
      error2: {
        desError: ''
      },
      error3: {
        desError: ''
      },
      error4: {
        desError: ''
      },
      error5: {
        desError: ''
      },
      error6: {
        desError: ''
      },
      trabajador: {
        idTrabajador: '0',
        nombres: '',
        apePaterno: '',
        apeMaterno: '',
        dni: '',
        cargo: '',
        correo: '',
        sigla: '',
        fecha_nac: new Date(),
        idAppXUsu: '0',
        idUsuario: '0',
        nomUsuario: '',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      trabxApp: {
        idAppXUsu: '0',
        idUsuario: '0',
        idApp: '0',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      rol: {
        idRol: '0',
        descripcion: '',
        idApp: '1',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      operacion: {
        idOperacion: '0',
        descripcion: '',
        idApp: '0',
        flagPrincipal: '0',
        enlaceWeb: '',
        idOpeSup: '0',
        idRol: '0',
        flagSeccion: 'I',
        icono: '',
        titulo_adic: '',
        icono_adic: '',
        descripcion_adic: '',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      rolById: [],
      vidUsu: '0',
      rolByUsu: {
        idRol: '0',
        idUsuario: '0',
        idApp: '1',
        flagActivo: '1',
        idRolXUsu: '0',
        usuario: this.$session.get('user')
      },
      rolByOpe: {
        idRol: '0',
        idOpeXRol: '0',
        idOperacion: '0',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      opeByRol: {
        idRol: '0',
        idOpeXRol: '0',
        idOperacion: '0',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      usuByRol: {
        idRol: '0',
        idUsuario: '0',
        idApp: '1',
        flagActivo: '1',
        idRolXUsu: '0',
        usuario: this.$session.get('user')
      },
      usuarios: [],
      idPer: '0',
      selectedIdPersonal: null,
      usuarioSeleccionado: {},
      searchText: '',
      datosPer: null,
      usuByApp: {
        idUsuario: '0',
        idAppXUsu: '0',
        idApp: this.idApp,
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      newRol: {
        idRol: '0',
        descripcion: '',
        idApp: this.idApp,
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      newOpe: {
        idOperacion: '0',
        descripcion: '',
        idApp: this.idApp,
        flagPrincipal: '0',
        enlaceWeb: '',
        idOpeSup: '0',
        idRol: '0', //
        idOpeXRol: '0', //
        flagSeccion: 'I',
        icono: '',
        titulo_adic: '',
        icono_adic: '',
        descripcion_adic: '',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      cbOpes: [],
      //lastIdOpe: [],
      opesByOpeSup: [],
      opexrolArray5: [],
      idApp: localStorage.getItem('idApp'),
      descripcionApp: localStorage.getItem('desApp'), ///Obtiene la descripción del App almacenada
      tiempoActual: null,
      tiempoTokenExp: null
    }
  },
  components: {
    vSelect,
    VueTabs,
    VTab
  },
  mounted() {
    //this.tiempoActual = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });
    //this.tiempoTokenExp = localStorage.getItem('TokenExpirationTime')
    this.tiempoActual = moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a"); 
    this.tiempoTokenExp = moment(localStorage.getItem('TokenExpirationTime'), "D/M/YYYY, h:mm:ss a");

    if (!this.$session.exists('token')) {
      App.methods.logout.call(this);
      return;
    }

    if (this.tiempoActual < this.tiempoTokenExp) {
      if (this.idApp && this.idApp !== '' && this.descripcionApp && this.descripcionApp !== '') {
        this.cargarTrabajadores();
        this.cargarRoles();
        this.cargarOperaciones();
      } else {        
        //this.$router.push('/aplicaciones')
        this.$router.go(-1)
      }
    } else {
      this.alertaError401();
    }
  },
  methods: {
    ////Para el funcionamiento en vue-tabs
    handleTabChange(tabIndex, newTab, oldTab) {
      //console.log(tabIndex, newTab.title, oldTab.title);
    },
    /////////////// LISTAR ////////
    cargarTrabajadores() {
      // Destruir la instancia DataTable si ya existe
      const dataTableInstance = $('#tablaTrabajadores').DataTable();
      if (dataTableInstance) {
        dataTableInstance.destroy();
      }
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(`${apiURL}/usuarios/trabajadores/` + this.idApp)
        .then(response => {
          this.trabajadores = response.data;
          //console.log('Trabajadores obtenidos:', this.trabajadores);

          this.$nextTick(() => {
            $('#tablaTrabajadores').DataTable({
              stateSave: true,
              'stateSaveParams': function (settings, data) {
                data.length = 25; // Establece la longitud de la página
              },
              pageLength: 25,
              'oLanguage': {
                'sSearch': 'Buscar',
                'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
                'sEmptyTable': 'Sin Data',
                'ZeroRecords': 'No se encontraron coincidencias',
                'sInfoFiltered': '(filtrado de un total de _MAX_ registros)',
                'sLengthMenu': '_MENU_ Registros por pagina',
                'oPaginate': {
                  'sPrevious': 'Anterior',
                  'sNext': 'Siguiente'
                }
              }
            });
          });
        })
        .catch(error => {
          //console.error('Error al obtener trabajadores de la Aplicación:', error);
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        });
    },
    cargarRoles() {
      // Destruir la instancia DataTable si ya existe
      const dataTableInstance2 = $('#tablaRoles').DataTable();
      if (dataTableInstance2) {
        dataTableInstance2.destroy();
      }

      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      // Llamar a la API para obtener roles según la idApp de la Aplicación obtenida
      //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/rolByApp/' + this.idApp 
      axios.get(`${apiURL}/operaciones/rolByApp/` + this.idApp)
        .then(response => {
          this.rols = response.data;
          //console.log('Roles obtenidos:', this.rols);

          this.$nextTick(() => {
            $('#tablaRoles').DataTable({
              stateSave: true,
              'stateSaveParams': function (settings, data) {
                data.length = 25; // Establece la longitud de la página
              },
              pageLength: 25,
              'oLanguage': {
                'sSearch': 'Buscar',
                'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
                'sEmptyTable': 'Sin Data',
                'ZeroRecords': 'No se encontraron coincidencias',
                'sInfoFiltered': '(filtrado de un total de _MAX_ registros)',
                'sLengthMenu': '_MENU_ Registros por pagina',
                'oPaginate': {
                  'sPrevious': 'Anterior',
                  'sNext': 'Siguiente'
                }
              }
            });
          });
        })
        .catch(error => {
          //console.error('Error al obtener roles de la Aplicación:', error);
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          } else if (error.response && error.response.status === 404) {
            App.methods.logout.call(this);
          }
        });
    },
    cargarOperaciones() {
      // Destruir la instancia DataTable si ya existe
      const dataTableInstance3 = $('#tablaOperaciones').DataTable();
      if (dataTableInstance3) {
        dataTableInstance3.destroy();
      }

      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      // Llamar a la API para obtener las operaciones según la idApp de la Aplicación obtenida
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/*/' + this.idApp + '/0'
        `${apiURL}/operaciones/*/` + this.idApp + '/0'
      ).then(response => {
        this.operaciones = response.data;
        //console.log('Operaciones obtenidas:', this.operaciones);

        this.$nextTick(() => {
          $('#tablaOperaciones').DataTable({
            stateSave: true, // Guarda el estado y la paginación de la tabla
            'stateSaveParams': function (settings, data) {
              data.length = 25; // Establece la longitud de la página
            },
            pageLength: 25,
            'oLanguage': {
              'sSearch': 'Buscar',
              'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
              'sEmptyTable': 'Sin Data',
              'ZeroRecords': 'No se encontraron coincidencias',
              'sInfoFiltered': '(Filtrado de un total de _MAX_ registros)',
              'sLengthMenu': '_MENU_ Registros por pagina',
              'oPaginate': {
                'sPrevious': 'Anterior',
                'sNext': 'Siguiente'
              }
            }
          })
        })
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },

    //////////////// ANULAR ////////////////////////
    ///////// ANULAR TRABAJADORES X APP////////////
    /// ver Anular Trabajadfores x App
    verAnularTrabxApp: function (trabajador) {
      this.trabajador = trabajador
      this.trabajador.flagActivo = '0'
      this.obtenerRolsxUsu(trabajador.idUsuario);
    },
    /// Anular Trabajadores x App
    anularTrabxApp: function (trabxApp) {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        this.trabxApp.idAppXUsu = trabxApp.idAppXUsu
        this.trabxApp.idUsuario = trabxApp.idUsuario

        axios.post(
          `${apiURL}/operaciones/appByUsu/add`,
          {
            'idAppXUsu': this.trabxApp.idAppXUsu,
            'idUsuario': this.trabxApp.idUsuario,
            'flagActivo': '0',
            'usuario': this.$session.get('user')
          }
        ).then(response => {
          this.error = response.data

          ///Se anulará cada rol del Usuario en esta aplicación      
          this.rolById.forEach((array) => {
            this.anularRolByUsu(array);
          });
          //Después de anular al trabajador, recargar la lista
          this.cargarTrabajadores();
        })
          .catch(error => {
            if (error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      } else {
        this.alertaError401();
      }
    },
    //Cargar Roles según el idUsuario y el idApp (y se ejecutará en el método verAnularTrabxApp) para luego ser eliminado
    obtenerRolsxUsu: function (vidUsu) {
      axios.get(
        `${apiURL}/operaciones/rolByUsu/` + vidUsu + '/' + this.idApp
      ).then(response => {
        this.rolById = response.data
        //console.log('Roles según el idUsuario en esta App:', this.rolById);
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    ///Método para eliminar cada Rol del Usuario en esta aplicación, se ejecutará en el método anularTrabxApp
    anularRolByUsu: function (rolByUsu) {
      this.rolByUsu.idUsuario = rolByUsu.idUsuario
      this.rolByUsu.idRolXUsu = rolByUsu.idRolXUsu
      axios.post(
        `${apiURL}/operaciones/rolByUsu/add`,
        {
          'idUsuario': this.rolByUsu.idUsuario,
          'idRol': this.rolByUsu.idRol,
          'idRolXUsu': this.rolByUsu.idRolXUsu,
          'flagActivo': '0',
          'usuario': this.$session.get('user')
        }
      ).then(response => {
        this.error = response.data
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    ////////////////////////////////////
    ////// ANULAR ROLES X APP ///////////
    /////Ver Anular Roles x App
    verAnularRolxApp: function (rol) {
      this.rol = { ...rol }
      this.rol.flagActivo = '0'
      // Llamar al método para Obtener todas las opexrol según id de Rol //
      this.obtenerOpeByRol(rol.idRol);
      this.obtenerUsuByRol(rol.idRol);
    },
    anularRolxApp: function () {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        axios.post(
          //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/rol/add',
          `${apiURL}/operaciones/rol/add`,
          {
            'idRol': this.rol.idRol,
            'descripcion': this.rol.descripcion,
            'idApp': this.rol.idApp,
            'flagActivo': this.rol.flagActivo,
            'usuario': this.$session.get('user')
          }
        ).then(response => {
          this.error2 = response.data

          // Llamar al método anularOpexRolByRol para Anular las opexrol // 
          this.opeByRol.forEach((array3) => {
            //// Anular con flagActivo 0 en tabla operacionxrol
            this.anularOpexRolByRol(array3);
            //console.log('array3 opeByRol--', array3)

            ////Anular con flagActivo 0 en tabla operacion
            axios.post(
              //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/ope/add',
              `${apiURL}/operaciones/ope/add`,
              {
                'idOperacion': array3.idOperacion,
                'descripcion': array3.descripcion,
                'idApp': array3.idApp,
                'flagPrincipal': array3.flagPrincipal,
                'enlaceWeb': array3.enlaceWeb,
                'idOpeSup': array3.idOpeSup,
                'flagSeccion': array3.flagSeccion,
                'icono': array3.icono,
                'titulo_adic': array3.titulo_adic,
                'icono_adic': array3.icono_adic,
                'descripcion_adic': array3.descripcion_adic,
                'flagActivo': 0,
                'usuario': this.$session.get('user')
              }
            ).then(response => {
              this.error3 = response.data
            }).catch(error => {
              if (error.response && error.response.status === 401) {
                App.methods.logout.call(this);
              }
            })
            ////////
          });
          // Llamar al método  para Anular las rolxusuario // 
          this.usuByRol.forEach((array4) => {
            this.anularUsuByRol(array4);
          });

          this.cargarRoles();
          this.cargarOperaciones();
        })
          .catch(error => {
            if (error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      } else {
        this.alertaError401();
      }
    },
    //// Obtener las opexrol según id de Operación, se usa en método verAnularRolxApp
    obtenerOpeByRol: function (vidRol) {
      axios.get(
        `${apiURL}/operaciones/opexrolByRol/` + vidRol
      ).then(response => {
        this.opeByRol = response.data
        //console.log('---- opexrol x id de Rol--:', this.opeByRol);
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    //// Obtener los rolxusuario según id de Rol, se usa en método verAnularRolxApp 
    obtenerUsuByRol: function (vidRol) {
      axios.get(
        `${apiURL}/operaciones/usuByRol/` + vidRol + '/' + this.idApp
      ).then(response => {
        this.usuByRol = response.data
        //console.log('--- rolxusuario x id de Rol--:', this.usuByRol);
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    //// Anular los rolxusuario según id de Rol, se usa en método anularRolxApp
    anularUsuByRol: function (usuByRol) {
      this.usuByRol.idUsuario = usuByRol.idUsuario
      this.usuByRol.idRolXUsu = usuByRol.idRolXUsu
      axios.post(
        `${apiURL}/operaciones/rolByUsu/add`,
        {
          'idUsuario': this.usuByRol.idUsuario,
          'idRol': this.usuByRol.idRol,
          'idRolXUsu': this.usuByRol.idRolXUsu,
          'flagActivo': '0',
          'usuario': this.$session.get('user')
        }
      ).then(response => {
        this.error = response.data
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    //////// --------------------------------------------------------///////////
    ///////// ANULAR OPERACIONES X APP ///////////
    //// ver Anular Operaciones x App
    verAnularOpexApp: function (operacion) {
      this.operacion = { ...operacion }
      this.operacion.flagActivo = '0'
      //console.log('----', this.operacion);
      // Llamar al método para Obtener todas las opexrol según id de Operación //
      this.obtenerOpexRolByOpe(operacion.idOperacion);
    },
    anularOpexApp: function () {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        axios.post(
          //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/ope/add',
          `${apiURL}/operaciones/ope/add`,
          {
            'idOperacion': this.operacion.idOperacion,
            'descripcion': this.operacion.descripcion,
            'idApp': this.operacion.idApp,
            'flagPrincipal': this.operacion.flagPrincipal,
            'enlaceWeb': this.operacion.enlaceWeb,
            'idOpeSup': this.operacion.idOpeSup,
            'flagSeccion': this.operacion.flagSeccion,
            'icono': this.operaciones.icono,
            'titulo_adic': this.operacion.titulo_adic,
            'icono_adic': this.operacion.icono_adic,
            'descripcion_adic': this.operacion.descripcion_adic,
            'flagActivo': this.operacion.flagActivo,
            'usuario': this.$session.get('user')
          }
        ).then(response => {
          this.error3 = response.data

          //////Para Eliminar las idOpeSup conectadas a una Operación a anular u Operación que deja de ser Principal
          ///// Solo si idflagPrincipal es diferente de 0 y si existe idOperacion (al modificar operacion) o su flagActivo es '0' (al anular operacion)
          if (this.operacion.flagPrincipal !== 0 && this.operacion.flagActivo == '0') {
            /////Cargamos todas las operaciones y filtramos solo las que su idOpeSup sean igual al this.ope.idOperacion
            axios.get(
              `${apiURL}/operaciones/*/` + this.idApp + '/0'
            ).then(response => {
              this.opesByOpeSup = response.data.filter(item => item.idOpeSup === this.operacion.idOperacion);
              //console.log('opesByOpeSup filtradas por idOpeSup:', this.opesByOpeSup);

              ////Hacemos un forEach para realizar el cambio en idOpeSup a cada operación obtenida
              this.opesByOpeSup.forEach((array5) => {
                ///////Y le cambiamos el ideOpeSup a '0'
                axios.post(
                  //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/ope/add',
                  `${apiURL}/operaciones/ope/add`,
                  {
                    'idOperacion': array5.idOperacion,
                    'descripcion': array5.descripcion,
                    'idApp': array5.idApp,
                    'flagPrincipal': array5.flagPrincipal,
                    'enlaceWeb': array5.enlaceWeb,
                    'idOpeSup': array5.idOpeSup,
                    'flagSeccion': array5.flagSeccion,
                    'icono': array5.icono,
                    'titulo_adic': array5.titulo_adic,
                    'icono_adic': array5.icono_adic,
                    'descripcion_adic': array5.descripcion_adic,
                    'flagActivo': '0',
                    'usuario': this.$session.get('user')
                  }
                ).then(response => {
                  this.error5 = response.data

                  ////Después de Anular Operación dependientes de OpeSup, también anular sus operacionxrol en caso el idRol del array5 no sea '0'
                  if (array5.idRol !== 0) {
                    axios.get(
                      `${apiURL}/operaciones/opexrolByOpe/` + array5.idOperacion
                    ).then(response => {
                      this.opexrolArray5 = response.data

                      if (this.opexrolArray5.length > 0) {
                        this.opexrolArray5.forEach((array6) => {
                          axios.post(
                            //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/opeByRol/add',
                            `${apiURL}/operaciones/opeByRol/add`,
                            {
                              'idOpeXRol': array6.idOpeXRol,
                              'idRol': array6.idRol,
                              'idOperacion': array6.idOperacion,
                              'flagActivo': '0',
                              'usuario': this.$session.get('user')
                            }
                          ).then(response => {
                            this.error6 = response.data
                            this.cargarOperaciones();
                          })
                            .catch(error6 => {
                              if (error6.response && error6.response.status === 401) {
                                App.methods.logout.call(this);
                              }
                            })
                        })
                      }
                    })
                      .catch(error7 => {
                        if (error7.response && error7.response.status === 401) {
                          App.methods.logout.call(this);
                        }
                      })
                  } else {
                    this.cargarOperaciones();
                  }
                })
                  .catch(error5 => {
                    if (error5.response.status === 401) {
                      App.methods.logout.call(this);
                    }
                  })
              });
            })
              .catch(error5 => {
                if (error5.response.status === 401) {
                  App.methods.logout.call(this);
                }
              })
          }

          //// Llamar al método para Anular las opexrol según id de Operación obtenidas, si rolByOpe obtuvo datos// 
          if (this.rolByOpe.length !== 0) {
            //console.log('Hay datos en rolByOpe')
            this.rolByOpe.forEach((array2) => {
              this.anularOpexRolByRol(array2);
            });
          }
          else {
            //console.log('No hay datos en rolByOpe')
          }
          this.cargarOperaciones();

        })
          .catch(error => {
            if (error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      } else {
        this.alertaError401();
      }
    },
    ///////////////////////////    
    //// Obtener las opexrol según id de Operación
    obtenerOpexRolByOpe: function (vidOpe) {
      axios.get(
        `${apiURL}/operaciones/opexrolByOpe/` + vidOpe
      ).then(response => {
        this.rolByOpe = response.data
        //console.log('---- opexrol x id de Operación--:', this.rolByOpe);
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    //// Anular las opexrol según de Operación obtenidas, se usa en métodos anularOpexApp y anularRolxApp   
    anularOpexRolByRol: function (rolByOpe) {
      this.rolByOpe.idOpeXRol = rolByOpe.idOpeXRol
      axios.post(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/opeByRol/add',
        `${apiURL}/operaciones/opeByRol/add`,
        {
          'idOpeXRol': this.rolByOpe.idOpeXRol,
          'idRol': this.rolByOpe.idRol,
          'idOperacion': this.rolByOpe.idOperacion,
          'flagActivo': '0',
          'usuario': this.$session.get('user')
        }
      ).then(response => {
        this.error3 = response.data

      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },

    /////////////// AGREGAR //////////////////    
    //////////// AGREGAR PERSONAL ///////////////
    getAllPersonal: function () {
      //// Obtener todos los usuarios al combobox del modal Agregar Nuevo Personal      
      this.datosPer = null;
      this.selectedIdPersonal = null;
      this.usuarioSeleccionado = {
        nombres: '',
        apePaterno: '',
        apeMaterno: '',
      };
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/usuarios/*'
        `${apiURL}/usuarios/*`
      ).then(response => {
        this.usuarios = response.data
        //console.log('--- usuarios totales obtenidos', this.usuarios);
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      this.texto = 'REGISTRAR NUEVO USUARIO <br>AL ' + this.descripcionApp
    },
    ////Se une 2 métodos para ejecutarse a la vez en el combobox del modalNuevoPersonal
    inputHandler() {
      this.selectPersonal();
      this.getDatosPersonal();
    },
    //// Se ejecuta para llevar los datos del combobox a los input del modalNuevoPersonal
    selectPersonal() {
      if (this.selectedIdPersonal && this.selectedIdPersonal.idTrabajador) {
        const newId = this.selectedIdPersonal.idTrabajador;
        this.usuarioSeleccionado = this.usuarios.find(u => u.idTrabajador === newId) || {};
        //console.log('Usuario seleccionado:', this.usuarioSeleccionado);
      } else {
        //console.warn('selectedIdPersonal es null o no tiene idTrabajador');
        this.usuarioSeleccionado = {};
        this.datosPer = null;
      }
    },
    getDatosPersonal: function () {
      //// Obtener todos los datos del personal obtenido en getAllPersonal en modal Agregar Nuevo Personal
      if (this.selectedIdPersonal && this.selectedIdPersonal.idTrabajador) {
        axios.get(
          `${apiURL}/usuarios/trabajador/` + this.selectedIdPersonal.idTrabajador
        ).then(response => {
          this.datosPer = response.data
          //console.log('--- datosPer', this.datosPer);
        })
          .catch(error => {
            if (error.response.status === 401) {
              App.methods.logout.call(this);
            }
          });
      } else {
        //console.warn('selectedIdPersonal es null o no tiene idTrabajador');
      }
    },
    mergePersonal: function (vidUsu) {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        this.usuByApp.idUsuario = vidUsu
        axios.post(
          `${apiURL}/operaciones/appByUsu/add`,
          {
            'idAppXUsu': '0',
            'idUsuario': this.usuByApp.idUsuario,
            'idApp': this.usuByApp.idApp,
            'flagActivo': this.usuByApp.flagActivo,
            'usuario': this.$session.get('user')
          }
        ).then(response => {
          this.error = response.data
          this.cargarTrabajadores();
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      } else {
        this.alertaError401();
      }
    },

    ////// AGREGAR Y MODIFICAR ROL //////////////
    ////Al editar Rol
    verRol(newRol) {
      this.texto = 'ACTUALIZAR LOS DATOS DEL ROL';
      this.newRol = { ...newRol };
      //console.log('JJJ:', this.newRol);
    },
    ///Al abrir modalNuevoRol
    limpiarRol: function () {
      this.texto = 'REGISTRAR NUEVO ROL<br> AL ' + this.descripcionApp
      this.newRol.idRol = '0'
      this.newRol.descripcion = ''
      this.newRol.idApp = this.idApp
      this.newRol.flagActivo = '1'
    },

    //// REGISTRAR UN ROL A ESTA APLICACIÓN  
    mergeRol: function () {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        //console.log('GGG:', this.newRol);
        axios.post(
          `${apiURL}/operaciones/rol/add`,
          {
            'idRol': this.newRol.idRol,
            'descripcion': this.newRol.descripcion,
            'idApp': this.idApp,
            'flagActivo': this.newRol.flagActivo,
            'usuario': this.$session.get('user')
          }
        ).then(response => {
          this.error2 = response.data
          this.cargarRoles();
          this.cargarOperaciones();
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      } else {
        this.alertaError401();
      }
    },

    ////////////////////////////////////////////////
    ///////////// AGREGAR Y MODIFICAR OPERACION

    ///// Se ejecuta al abrir modal para Editar Nueva Operación
    verOperacion: function (newOpe) {
      ////cargaOpeSup() 
      axios.get(
        `${apiURL}/operaciones/*/` + this.idApp + '/1'
      ).then(response => {
        this.cbOpes = response.data
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })

      this.texto = 'ACTUALIZAR LOS DATOS DE LA OPERACIÓN'
      this.newOpe = { ...newOpe };
    },

    //////Se ejecuta al abrir modal para Registrar Nueva Operación
    limpiarOperacion: function () {
      ////cargaOpeSup() <--
      axios.get(
        `${apiURL}/operaciones/*/` + this.idApp + '/1'
      ).then(response => {
        this.cbOpes = response.data
        //console.log('cbOpes -----2', this.cbOpes); ///cargaOpeSup
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })

      this.texto = 'REGISTRAR NUEVA OPERACIÓN <br>AL ' + this.descripcionApp
      this.newOpe.idOperacion = '0'
      this.newOpe.descripcion = ''
      this.newOpe.idApp = this.idApp
      this.newOpe.flagPrincipal = '0'
      this.newOpe.enlaceWeb = ''
      this.newOpe.idOpeSup = '0'
      this.newOpe.idRol = '0'
      this.newOpe.flagSeccion = 'I'
      this.newOpe.icono = ''
      this.newOpe.titulo_adic = ''
      this.newOpe.icono_adic = ''
      this.newOpe.descripcion_adic = ''
      this.newOpe.flagActivo = '1'
    },
    mergeOperacion: function () {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        axios.post(
          //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/ope/add',
          `${apiURL}/operaciones/ope/add`,
          {
            'idOperacion': this.newOpe.idOperacion,
            'descripcion': this.newOpe.descripcion,
            'idApp': this.idApp,
            'flagPrincipal': this.newOpe.flagPrincipal,
            'enlaceWeb': this.newOpe.enlaceWeb,
            'idOpeSup': this.newOpe.idOpeSup,
            'flagSeccion': this.newOpe.flagSeccion,
            'icono': this.newOpe.icono,
            'titulo_adic': this.newOpe.titulo_adic,
            'icono_adic': this.newOpe.icono_adic,
            'descripcion_adic': this.newOpe.descripcion_adic,
            'flagActivo': this.newOpe.flagActivo,
            'usuario': this.$session.get('user')
          }
        ).then(response => {
          this.error3 = response.data

          //////Para Eliminar idOpeSup conectadas a una Operación a Anularse o que deja de ser SI Principal
          ///// Solo si idflagPrincipal es diferente de 0 y si existe idOperacion (al modificar operacion) o su flagActivo es '0' (al anular operacion)
          if (this.newOpe.flagPrincipal == 0 && this.newOpe.idOperacion !== '0' && this.newOpe.flagActivo !== '0') {
            /////Cargamos todas las operaciones y filtramos solo las que su idOpeSup sean igual al this.ope.idOperacion
            axios.get(
              `${apiURL}/operaciones/*/` + this.idApp + '/0'
            ).then(response => {
              this.opesByOpeSup = response.data.filter(item => item.idOpeSup === this.newOpe.idOperacion);
              //console.log('opesByOpeSup filtradas por idOpeSup:', this.opesByOpeSup);

              ////Hacemos un forEach para realizar el cambio en idOpeSup a cada operación obtenida
              this.opesByOpeSup.forEach((array5) => {
                ///////Y le cambiamos el ideOpeSup a '0'
                axios.post(
                  `${apiURL}/operaciones/ope/add`,
                  {
                    'idOperacion': array5.idOperacion,
                    'descripcion': array5.descripcion,
                    'idApp': array5.idApp,
                    'flagPrincipal': array5.flagPrincipal,
                    'enlaceWeb': array5.enlaceWeb,
                    'idOpeSup': '0',
                    'flagSeccion': array5.flagSeccion,
                    'icono': array5.icono,
                    'titulo_adic': array5.titulo_adic,
                    'icono_adic': array5.icono_adic,
                    'descripcion_adic': array5.descripcion_adic,
                    'flagActivo': array5.flagActivo,
                    'usuario': this.$session.get('user')
                  }
                ).then(response => {
                  this.error6 = response.data
                  this.cargarOperaciones();
                })
                  .catch(error6 => {
                    if (error6.response.status === 401) {
                      App.methods.logout.call(this);
                    }
                  })
              });
            })
              .catch(error6 => {
                if (error6.response.status === 401) {
                  App.methods.logout.call(this);
                }
              })
          }

          //// Si existe Rol o se ha seleccionado un Rol del combobox
          if (this.newOpe.idRol !== '0' && this.newOpe.idOperacion == '0' || this.newOpe.idRol !== 0 && this.newOpe.idOperacion !== '0') {
            //////Obtener el ultimo Id Operación que se registro con el axios anterior, para enviarlo al siguiente axios, esto como this.lastIdOpe.idOperacion        
            axios.get(
              `${apiURL}/operaciones/lastIdOpe/` + this.newOpe.descripcion
            ).then(response => {
              this.lastIdOpe = response.data[0]
              //console.log('lastIdOpe -----', this.lastIdOpe.idOperacion);

              axios.post(
                //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/opeByRol/add',
                `${apiURL}/operaciones/opeByRol/add`,
                {
                  'idOpeXRol': this.newOpe.idOpeXRol,
                  'idRol': this.newOpe.idRol,
                  /// En Agregar Nuevo (idOperacion = '0') usar lasIdOpe.idOperacion, mientras que en Editar usar newOpe.idOperacion 
                  'idOperacion': this.newOpe.idOperacion !== '0' ? this.newOpe.idOperacion : this.lastIdOpe.idOperacion,
                  'flagActivo': '1',
                  'usuario': this.$session.get('user')
                }
              ).then(response => {
                this.error4 = response.data
                this.cargarOperaciones();
              })
                .catch(error => {
                  if (error.response && error.response.status === 401) {
                    App.methods.logout.call(this);
                  }
                })
            })
              .catch(error => {
                if (error.response && error.response.status === 401) {
                  App.methods.logout.call(this);
                }
              })
          } else {
            this.cargarOperaciones();
          }
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      } else {
        this.alertaError401();
      }
    },
    formatDate(dateString) {
      if (dateString) {
        const date = new Date(dateString);
        date.setDate(date.getDate() + 1); // Sumar un día
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return '';
    },
    /// resetear el combobox de Roles en el modal NuevaOperacion
    resetSelection() {
      this.newOpe.idRol = '0';
    },
    /// resetear el combobox de OpeSup en el modal NuevaOperacion
    resetSelection2() {
      this.newOpe.idOpeSup = '0';
    },
    enviar(item, item2) {
      this.$store.commit('enviarCorreo', item);
      localStorage.setItem('userIdTrab', item2);
      this.$router.push('/aplicaciones_detalle');
    },

    alertaError() {
      Swal.fire({
        icon: 'error',
        title: 'Usuario No Autorizado',
        text: 'No tienes permisos para acceder.',
        timer: 2000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        //this.$router.go(-1);
        this.$router.push('/login')
      });
    },
    alertaError401() {
      Swal.fire({
        icon: 'error',
        title: 'La sesión ha expirado',
        //text: 'Vuelve a iniciar sesión.',
        footer: '<a href="#">Vuelve a iniciar sesión.</a>',
        timer: 3000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        //this.$session.destroy()
        //this.$router.push('/login')
        App.methods.logout.call(this); ///Cierra la sesión                 
      });
    },
    alertaError500() {
      Swal.fire({
        icon: 'error',
        title: 'Error interno del servidor',
        text: 'Ocurrió un error. Por favor, inténtalo de nuevo más tarde..',
        timer: 5000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        //this.$router.go(-1);
        this.$router.push('/login')
      });
    },
  },
  computed: {
    filteredUsuarios() {
      const lowerSearchText = this.searchText.toLowerCase();
      return this.usuarios.map(usu => {
        // Verificamos que usu sea un objeto y tenga las propiedades necesarias
        if (usu && usu.nombres && usu.apePaterno && usu.apeMaterno) {
          return {
            ...usu,
            nombreCompleto: `${usu.nombres} ${usu.apePaterno} ${usu.apeMaterno}`
          };
        }
        return null;
      }).filter(usu => usu && (
        usu.nombres.toLowerCase().includes(lowerSearchText) ||
        usu.apePaterno.toLowerCase().includes(lowerSearchText) ||
        usu.apeMaterno.toLowerCase().includes(lowerSearchText)
      ));
    },

  },
  ///Para borrar el valor del userMail actual al salir de la ventana
  beforeRouteLeave(to, from, next) {
    // Verifica si la ruta de destino NO es 'usuarios'
    if (to.name !== 'usuarios') {
      localStorage.removeItem('idApp')
      // Limpia la desApp (descripción del App) antes de salir de la ruta
      localStorage.setItem('desApp', '')
    }
    next();
  }
}
</script>

<style>
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}

.fuente.box-title.p-t-10 {
  display: grid;
  place-items: center;
  font-weight: bold;
  /*text-decoration: underline;*/
}

.fuente.box-title.p-t-5 {
  font-weight: bold;
  font-size: 15px;
  padding-left: 15px;
}

/* Estilos adicionales para las tablas */
.table {
  border-collapse: collapse;
  width: 100%;
}

.table,
.table th,
.table td {
  border: 1px solid #ddd;
}

.border-table {
  border: 1px solid #ddd;
}

.combobox-personalizado {
  margin-left: 0px;
  width: 550px;
  font-size: 14px;
  /* font-weight: bold;*/
  font-family: "Arial";
  color: black;
}

.input-personalizado2 {
  width: 250px;
  font-size: 14px;
  font-family: "Arial", sans-serif;
  color: black;
}

.fuente .vs__search {
  font-size: 16px !important;
  /* ajusta el tamaño del texto de búsqueda del combobox del modalNuevoPersonal*/
}

.clear-button {
  padding: 2px 5px;
  background-color: #ffffff;
  border: 0px solid #ccc;
  cursor: pointer;
  margin-left: -38px;
  border-radius: 50%;
}

.tabs {
  display: flex;
}

.tab {
  flex: 1;
  text-align: center;
}

.vue-tabs .v-tabs-header {
  border-radius: 10px;
  overflow: hidden;
}

.vue-tabs .v-tab {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.custom-cursor {
  cursor: pointer;
}

.disabled-button2 {
  margin-right: 65px;
  margin-top: 10px;
}

.enabled-button2 {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// Aplication_Detalle.vue?c9fafd54